import "@arco-design/web-react/dist/css/arco.css";
import "@/index.css";
import "@/i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/router";
import { applyExternalTokenFromUrl } from "@/utils/externalLoginFromUrl";


applyExternalTokenFromUrl();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
